module.exports = __webpack_public_path__ + "assets/img/question-circle.2ec21699.svg";